/** A ghost button on the blue header bar: white text, and the opaque primary-hover on hover. */
export const headerButton =
  'h-10 px-2 text-base text-primary-foreground hover:bg-primary-hover hover:text-primary-foreground sm:px-3 sm:text-xl [&_svg]:size-5'
